module.exports = __webpack_public_path__ + "static/media/looking2.3802552f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/About/images/looking2.png
// module id = 101
// module chunks = 0